import React, { useEffect, useState } from "react";
import { useAuthContext } from "../context/Auth";
import Loading from "../views/Loading";

const ZendeskLoading = () => {
  const { tokenRenew } = useAuthContext();
  const [error, setError] = useState(null);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const fetchTokenAndRedirect = async () => {
      try {
        // Wait for the token renewal process
        const tokenRenewed = await tokenRenew();

        if (tokenRenewed) {
          // Check localStorage for token after renewal
          const newToken = localStorage.getItem("zendeskSupportToken");
          console.log("New Token:", newToken);

          if (newToken) {
            console.log("Redirecting to Zendesk...");
            window.location.href = `https://docupathaihelp.zendesk.com/access/jwt?&return_to=https://help.docupath.app/requests/new&jwt=${newToken}`;
          } else {
            throw new Error("Zendesk token not found.");
          }
        } else {
          throw new Error("Token renewal failed.");
        }
      } catch (error) {
        console.error("Error fetching Zendesk token:", error);
        setError("Oops! We couldn't connect you to the help center.");

        // Start countdown before closing
        let counter = 3;
        const interval = setInterval(() => {
          setCountdown((prev) => {
            if (prev === 1) {
              clearInterval(interval);
              window.close();
            }
            return prev - 1;
          });
        }, 1000);
      }
    };

    fetchTokenAndRedirect();
  }, []);

  return (
    <>
      {error ? (
        <Loading message={`${error} Closing in ${countdown}...`} />
      ) : (
        <Loading message="Authenticating with SSO... Almost there!" />
      )}
    </>
  );
};

export default ZendeskLoading;
